import { PrimeIndemnite } from '../types';
import { 
  Gift, Clock, MapPin, Stethoscope, Users, TrendingUp, Shield, Heart,
  Moon, Bus, Baby, AlertTriangle, Scale, Activity, Calendar, Globe,
  Home, Footprints, Award, Skull, UserCheck, HandHeart, GraduationCap
} from 'lucide-react';

/**
 * @fileoverview Auto-generated fallback primes data from Supabase
 * 
 * This file is automatically generated by scripts/generatePrimes.js
 * DO NOT EDIT MANUALLY - your changes will be overwritten
 * 
 * Generated on: 2026-08-18T14:38:01.178Z
 * Source: salaire_hopital table in Supabase
 * 
 * @author App'Ines Team (auto-generated)
 * @version 1.0.0
 * @since 2025
 */

export const GENERATED_PRIMES: PrimeIndemnite[] = [
  {
    "id": "segur",
    "nom": "Complément de traitement indiciaire (CTI)",
    "description": "Ancienne Prime Ségur - COVID",
    "montantDefaut": 241.22,
    "montantUtilisateur": 241.22,
    "active": false,
    "type": "variable",
    "icon": Heart,
    "color": "green",
    "details": "La prime de revalorisation (Ségur) versée à certains personnels relevant de la FPH exerçant au sein des établissements et services sociaux et médico-sociaux est transformée en complément de traitement indiciaire (CTI).",
    "calculable": true,
    "availableForProfessions": [
      "infirmier",
      "infirmiere-anesthesiste-iade",
      "infirmiere-bloc-operatoire-ibode",
      "infirmiere-puericultrice-ipde",
      "infirmiere-pratique-avancee-ipa"
    ],
    "proratisee": true,
    "formuleCode": "cti_segur_formula",
    "calculDetails": "La prime de revalorisation (Ségur) versée à certains personnels relevant de la FPH exerçant au sein des établissements et services sociaux et médico-sociaux est transformée en complément de traitement indiciaire (CTI).",
    "urlDoc": "https://www.fonction-publique.gouv.fr/etre-agent-public/ma-remuneration/les-elements-accessoires-de-remuneration/le-complement-de-traitement-indiciaire-cti",
    "ordre": 1,
    "eligibleEchelons": null,
    "primeType": "Globale",
    "eligibleStatuses": [
      "titulaire",
      "stagiaire",
      "contractuel"
    ],
    "aNegocier": false,
    "baseLegale": "Décret n°2020-1152 du 19/09/2020 - Complément de traitement indiciaire",
    "decretReference": "2020-1152",
    "noteCalcul": "49 points d'indice majoré × valeur du point courante.",
    "ctiPoints": 49
  },
  {
    "id": "veil",
    "nom": "Prime Spécifique : prime Veil",
    "description": "Prime instaurée en 1974 par Simone Veil",
    "montantDefaut": 90,
    "montantUtilisateur": 90,
    "active": false,
    "type": "fixe",
    "icon": Scale,
    "color": "pink",
    "details": "Instaurée en 1974 par Simone Veil, destinée aux infirmiers spécialisés. Facultative, dépend de chaque établissement.",
    "calculable": false,
    "availableForProfessions": [
      "infirmier",
      "infirmiere-anesthesiste-iade",
      "infirmiere-bloc-operatoire-ibode",
      "infirmiere-puericultrice-ipde",
      "infirmiere-pratique-avancee-ipa"
    ],
    "proratisee": false,
    "calculDetails": "Instaurée en 1974 par Simone Veil, destinée aux infirmiers spécialisés. Facultative, dépend de chaque établissement.",
    "urlDoc": "https://www.emploi-collectivites.fr/prime-infirmiere-specifique-veil-blog-territorial",
    "ordre": 2,
    "eligibleEchelons": null,
    "primeType": "Conditions de travail",
    "eligibleStatuses": [
      "titulaire",
      "stagiaire",
      "contractuel"
    ],
    "aNegocier": true,
    "baseLegale": "Décret n°88-1083 du 30/11/1988 - Prime spécifique aux infirmiers",
    "decretReference": "88-1083"
  },
  {
    "id": "prime_nuit",
    "nom": "Prime de nuit",
    "description": "Majoration de 25% pour le travail de nuit",
    "montantDefaut": 0,
    "montantUtilisateur": 0,
    "active": false,
    "type": "variable",
    "icon": Moon,
    "color": "indigo",
    "details": "Majoration de 25% du salaire de base pour les heures de travail de nuit.",
    "calculable": true,
    "availableForProfessions": [
      "infirmier",
      "infirmiere-anesthesiste-iade",
      "infirmiere-bloc-operatoire-ibode",
      "infirmiere-puericultrice-ipde",
      "infirmiere-pratique-avancee-ipa"
    ],
    "proratisee": false,
    "formuleCode": "prime_nuit_formula",
    "calculDetails": "Majoration de 25% du salaire de base pour les heures de travail de nuit.",
    "urlDoc": "https://sante.gouv.fr/fichiers/bo/2023/2023.22.sante.pdf",
    "ordre": 3,
    "eligibleEchelons": null,
    "primeType": "Conditions de travail",
    "eligibleStatuses": [
      "titulaire",
      "stagiaire",
      "contractuel"
    ],
    "aNegocier": false,
    "baseLegale": "Arrêté du 26/06/2023 - Majoration heures de nuit FPH",
    "decretReference": "arr. 26/06/2023",
    "dateRevalorisation": "2024-01-01",
    "noteCalcul": "Majoration de 25% du traitement horaire pour heures de nuit (21h-6h).",
    "primeNuitConfig": {
      "nuitsParMois": 0
    }
  },
  {
    "id": "soins_critiques",
    "nom": "Prime d'exercice en soins critiques",
    "description": "Prime pour les infirmiers en unités de soins critiques",
    "montantDefaut": 118,
    "montantUtilisateur": 118,
    "active": false,
    "type": "fixe",
    "icon": Activity,
    "color": "red",
    "details": "Créée en 2022 pour reconnaître le travail des infirmiers en unités de soins critiques. Montant fixé à 118€.",
    "calculable": false,
    "availableForProfessions": [
      "infirmier",
      "infirmiere-anesthesiste-iade",
      "infirmiere-bloc-operatoire-ibode",
      "infirmiere-puericultrice-ipde",
      "infirmiere-pratique-avancee-ipa"
    ],
    "proratisee": false,
    "calculDetails": "Créée en 2022 pour reconnaître le travail des infirmiers en unités de soins critiques. Montant fixé à 118€.",
    "urlDoc": "https://www.legifrance.gouv.fr/jorf/id/JORFTEXT000044901814",
    "ordre": 4,
    "eligibleEchelons": null,
    "primeType": "Conditions de travail",
    "eligibleStatuses": [
      "titulaire",
      "stagiaire",
      "contractuel"
    ],
    "aNegocier": false,
    "baseLegale": "Décret n°2022-737 du 28/04/2022 - Prime exercice en soins critiques",
    "decretReference": "2022-737",
    "noteCalcul": "118€ brut mensuel pour exercice dans une unité de soins critiques."
  },
  {
    "id": "iss",
    "nom": "Indemnité Spécifique",
    "description": "Ancienne Prime Sujétion Spéciale (ISS) - Prime des 13 heures",
    "montantDefaut": 0,
    "montantUtilisateur": 0,
    "active": false,
    "type": "fixe",
    "icon": Clock,
    "color": "green",
    "details": "Indemnité forfaitaire remplaçant l'ISS depuis 2021.",
    "calculable": true,
    "availableForProfessions": [
      "infirmier",
      "infirmiere-anesthesiste-iade",
      "infirmiere-bloc-operatoire-ibode",
      "infirmiere-puericultrice-ipde",
      "infirmiere-pratique-avancee-ipa"
    ],
    "proratisee": false,
    "formuleCode": "iss_formula",
    "calculDetails": "Indemnité forfaitaire remplaçant l'ISS depuis 2021.",
    "urlDoc": "https://www.legifrance.gouv.fr/jorf/id/JORFTEXT000044271973",
    "ordre": 5,
    "eligibleEchelons": null,
    "primeType": "Conditions de travail",
    "eligibleStatuses": [
      "titulaire",
      "stagiaire",
      "contractuel"
    ],
    "aNegocier": false,
    "baseLegale": "Décret n°2021-1627 du 10/12/2021 - Indemnité forfaitaire remplaçant ISS",
    "decretReference": "2021-1627",
    "dateRevalorisation": "2021-12-10",
    "noteCalcul": "Formule : (IM × valeur du point au 01/01/2021 soit 4,6860€ × 12) × 13/1900. La valeur du point de référence est volontairement gelée à celle de 2021 conformément au décret n°2021-1627 (montant équivalent à un temps plein).",
    "issConfig": {
      "echelonHistorique": 0,
      "indiceMajoreHistorique": 0
    }
  },
  {
    "id": "pss",
    "nom": "Prime Spéciale de Sujétion (PSS)",
    "description": "Prime compensant les difficultés spécifiques du poste",
    "montantDefaut": 0,
    "montantUtilisateur": 0,
    "active": false,
    "type": "fixe",
    "icon": AlertTriangle,
    "color": "purple",
    "details": "Compense les difficultés spécifiques du poste comme la pénibilité, horaires irréguliers, risques.",
    "calculable": true,
    "availableForProfessions": [
      "infirmier",
      "infirmiere-anesthesiste-iade",
      "infirmiere-bloc-operatoire-ibode",
      "infirmiere-puericultrice-ipde",
      "infirmiere-pratique-avancee-ipa"
    ],
    "proratisee": true,
    "formuleCode": "pss_formula",
    "calculDetails": "Compense les difficultés spécifiques du poste comme la pénibilité, horaires irréguliers, risques.",
    "urlDoc": "https://www.fonction-publique.gouv.fr/etre-agent-public/ma-remuneration/le-regime-indemnitaire-fixe/la-prime-speciale-de-sujetion-pss",
    "ordre": 6,
    "eligibleEchelons": null,
    "primeType": "Conditions de travail",
    "eligibleStatuses": [
      "titulaire",
      "stagiaire"
    ],
    "aNegocier": false,
    "baseLegale": "Décret n°98-1057 du 16/11/1998 - Prime spéciale de sujétion",
    "decretReference": "98-1057",
    "noteCalcul": "10% du traitement indiciaire brut. Réservée aux fonctionnaires."
  },
  {
    "id": "debut_carriere",
    "nom": "Prime spéciale de début de carrière",
    "description": "Prime attribuée aux infirmiers nouvellement embauchés",
    "montantDefaut": 38.35,
    "montantUtilisateur": 38.35,
    "active": false,
    "type": "fixe",
    "icon": Baby,
    "color": "orange",
    "details": "Aussi appelée prime de débutant. Montant de 38,35 € brut par mois.",
    "calculable": false,
    "availableForProfessions": [
      "infirmier"
    ],
    "proratisee": false,
    "calculDetails": "Aussi appelée prime de débutant. Montant de 38,35 € brut par mois.",
    "urlDoc": "https://www.legifrance.gouv.fr/loda/id/JORFTEXT000000223257",
    "ordre": 7,
    "eligibleEchelons": [
      1,
      2
    ],
    "primeType": "Conditions de travail",
    "eligibleStatuses": [
      "titulaire",
      "stagiaire",
      "contractuel"
    ],
    "aNegocier": false,
    "baseLegale": "Décret n°76-280 du 19/03/1976 - Prime spéciale de début de carrière",
    "decretReference": "76-280",
    "noteCalcul": "Montant forfaitaire brut mensuel de 38,35€. Réservée aux IDE échelons 1 et 2."
  },
  {
    "id": "transport",
    "nom": "Indemnité transport",
    "description": "Prise en charge des frais de transport",
    "montantDefaut": 30,
    "montantUtilisateur": 30,
    "active": false,
    "type": "variable",
    "icon": Bus,
    "color": "indigo",
    "details": "Remboursement à 75% des abonnements transports en commun (fonction publique).",
    "calculable": true,
    "availableForProfessions": [
      "infirmier",
      "infirmiere-anesthesiste-iade",
      "infirmiere-bloc-operatoire-ibode",
      "infirmiere-puericultrice-ipde",
      "infirmiere-pratique-avancee-ipa"
    ],
    "proratisee": false,
    "formuleCode": "transport_formula",
    "calculDetails": "Remboursement à 75% des abonnements transports en commun (fonction publique).",
    "urlDoc": "https://www.fonction-publique.gouv.fr/toutes-les-actualites/la-prise-en-charge-des-titres-de-transport-des-agents-passe-de-50-75",
    "ordre": 8,
    "eligibleEchelons": null,
    "primeType": "Compensation Frais ou Charges",
    "eligibleStatuses": [
      "titulaire",
      "stagiaire",
      "contractuel"
    ],
    "aNegocier": false,
    "baseLegale": "Décret n°2010-676 du 21/06/2010 - Prise en charge titres de transport",
    "decretReference": "2010-676",
    "dateRevalorisation": "2023-09-01",
    "noteCalcul": "Remboursement à 75% des abonnements transports en commun (depuis le 01/09/2023).",
    "montantBase": 40,
    "pourcentageRemboursement": 75
  },
  {
    "id": "indemnite_residence",
    "nom": "Indemnité de Résidence (IR)",
    "description": "Compensation du coût de la vie selon la zone géographique",
    "montantDefaut": 0,
    "montantUtilisateur": 0,
    "active": false,
    "type": "variable",
    "icon": Home,
    "color": "cyan",
    "details": "Versée aux IDE exerçant dans certaines zones géographiques où le coût de la vie est élevé.",
    "calculable": true,
    "availableForProfessions": [
      "infirmier",
      "infirmiere-anesthesiste-iade",
      "infirmiere-bloc-operatoire-ibode",
      "infirmiere-puericultrice-ipde",
      "infirmiere-pratique-avancee-ipa"
    ],
    "proratisee": false,
    "formuleCode": "ir_formula",
    "calculDetails": "Versée aux IDE exerçant dans certaines zones géographiques où le coût de la vie est élevé.",
    "urlDoc": "https://www.service-public.fr/particuliers/vosdroits/F32511",
    "ordre": 9,
    "eligibleEchelons": null,
    "primeType": "Géographique",
    "eligibleStatuses": [
      "titulaire",
      "stagiaire",
      "contractuel"
    ],
    "aNegocier": false,
    "baseLegale": "Décret n°85-1148 du 24/10/1985 - Indemnité de résidence",
    "decretReference": "85-1148",
    "noteCalcul": "Taux fonction de la zone INSEE : Zone 1 (3%), Zone 2 (1%), Zone 3 (0%)."
  },
  {
    "id": "iftd",
    "nom": "Indemnité de Travail des Dimanches et Jours Fériés (IFTD)",
    "description": "Indemnité pour le travail les dimanches et jours fériés",
    "montantDefaut": 0,
    "montantUtilisateur": 0,
    "active": false,
    "type": "variable",
    "icon": Calendar,
    "color": "teal",
    "details": "Réservée aux infirmiers exerçant les dimanches et les jours fériés.",
    "calculable": true,
    "availableForProfessions": [
      "infirmier",
      "infirmiere-anesthesiste-iade",
      "infirmiere-bloc-operatoire-ibode",
      "infirmiere-puericultrice-ipde",
      "infirmiere-pratique-avancee-ipa"
    ],
    "proratisee": false,
    "formuleCode": "iftd_formula",
    "calculDetails": "Réservée aux infirmiers exerçant les dimanches et les jours fériés.",
    "urlDoc": "https://www.emploi-collectivites.fr/iftd-prime-dimanche-blog-territorial",
    "ordre": 10,
    "eligibleEchelons": null,
    "primeType": "Conditions de travail",
    "eligibleStatuses": [
      "titulaire",
      "stagiaire",
      "contractuel"
    ],
    "aNegocier": false,
    "baseLegale": "Décret n°2023-1314 du 28/12/2023 - Indemnité dimanches et jours fériés FPH",
    "decretReference": "2023-1314",
    "dateRevalorisation": "2024-01-01",
    "noteCalcul": "Forfait de 60€ par jour travaillé (8h) un dimanche ou jour férié.",
    "iftdConfig": {
      "dimanchesParMois": 0,
      "joursFeriesTravailles": []
    }
  },
  {
    "id": "isg_dom",
    "nom": "Indemnité de Sujétion Géographique (ISG)",
    "description": "Prime pour les départements d'outre-mer (DOM)",
    "montantDefaut": 0,
    "montantUtilisateur": 0,
    "active": false,
    "type": "variable",
    "icon": Globe,
    "color": "orange",
    "details": "Versée aux agents affectés dans les DOM.",
    "calculable": false,
    "availableForProfessions": [
      "infirmier",
      "infirmiere-anesthesiste-iade",
      "infirmiere-bloc-operatoire-ibode",
      "infirmiere-puericultrice-ipde",
      "infirmiere-pratique-avancee-ipa"
    ],
    "proratisee": false,
    "calculDetails": "Versée aux agents affectés dans les DOM.",
    "urlDoc": "https://www.emploi-collectivites.fr/sujetion-geographique-isg-dom-tom-blog-territorial",
    "ordre": 11,
    "eligibleEchelons": null,
    "primeType": "Géographique",
    "eligibleStatuses": [
      "titulaire",
      "stagiaire",
      "contractuel"
    ],
    "aNegocier": false,
    "baseLegale": "Décret n°53-1266 du 22/12/1953 - Majoration de traitement outre-mer",
    "decretReference": "53-1266",
    "noteCalcul": "Majoration de traitement variable selon le département d'outre-mer (25% à 40%)."
  },
  {
    "id": "contagion",
    "nom": "Prime de contagion",
    "description": "Prime pour exposition aux risques infectieux",
    "montantDefaut": 12.54,
    "montantUtilisateur": 12.54,
    "active": false,
    "type": "variable",
    "icon": Shield,
    "color": "red",
    "details": "Réservée aux personnels exposés à des risques infectieux.",
    "calculable": true,
    "availableForProfessions": [
      "infirmier",
      "infirmiere-anesthesiste-iade",
      "infirmiere-bloc-operatoire-ibode",
      "infirmiere-puericultrice-ipde",
      "infirmiere-pratique-avancee-ipa"
    ],
    "proratisee": false,
    "formuleCode": "contagion_formula",
    "calculDetails": "Réservée aux personnels exposés à des risques infectieux.",
    "urlDoc": "https://www.legifrance.gouv.fr/jorf/id/JORFTEXT000047260256",
    "ordre": 12,
    "eligibleEchelons": null,
    "primeType": "Conditions de travail",
    "eligibleStatuses": [
      "titulaire",
      "stagiaire",
      "contractuel"
    ],
    "aNegocier": false,
    "baseLegale": "Décret n°67-624 du 23/07/1967 - Prime pour risques infectieux",
    "decretReference": "67-624",
    "noteCalcul": "0,33€ par demi-journée d'exposition à un risque infectieux.",
    "contagionConfig": {
      "joursTravaillesParAn": 228
    }
  },
  {
    "id": "sft",
    "nom": "Supplément Familial de Traitement (SFT)",
    "description": "Prime pour les agents ayant au moins un enfant à charge",
    "montantDefaut": 0,
    "montantUtilisateur": 0,
    "active": false,
    "type": "variable",
    "icon": Users,
    "color": "emerald",
    "details": "Composante obligatoire. Part fixe + part proportionnelle au traitement indiciaire (à partir de 2 enfants).",
    "calculable": true,
    "availableForProfessions": [
      "infirmier",
      "infirmiere-anesthesiste-iade",
      "infirmiere-bloc-operatoire-ibode",
      "infirmiere-puericultrice-ipde",
      "infirmiere-pratique-avancee-ipa"
    ],
    "proratisee": false,
    "formuleCode": "sft_formula",
    "calculDetails": "Composante obligatoire. Part fixe + part proportionnelle au traitement indiciaire (à partir de 2 enfants).",
    "urlDoc": "https://outils.cisirh.gouv.fr/calculatrice-sft/form",
    "ordre": 13,
    "eligibleEchelons": null,
    "primeType": "Globale",
    "eligibleStatuses": [
      "titulaire",
      "stagiaire",
      "contractuel"
    ],
    "aNegocier": false,
    "baseLegale": "Article 20 de la loi n°83-634 du 13/07/1983 - Décret n°85-1148 du 24/10/1985",
    "decretReference": "85-1148",
    "noteCalcul": "Composante obligatoire du traitement. Part fixe + part proportionnelle plafonnée entre IM 454 et IM 722.",
    "sftConfig": {
      "nombreEnfants": 0
    }
  },
  {
    "id": "chaussures",
    "nom": "Indemnité de chaussures et de petit équipement (ICPE)",
    "description": "",
    "montantDefaut": 2.73,
    "montantUtilisateur": 2.73,
    "active": false,
    "type": "fixe",
    "icon": Footprints,
    "color": "amber",
    "details": "Compensation indemnitaire pour l'usage et l'usure de chaussures et de petit équipement personnels. 32,74€/an",
    "calculable": false,
    "availableForProfessions": [
      "infirmier",
      "infirmiere-anesthesiste-iade",
      "infirmiere-bloc-operatoire-ibode",
      "infirmiere-puericultrice-ipde",
      "infirmiere-pratique-avancee-ipa"
    ],
    "proratisee": false,
    "calculDetails": "Compensation indemnitaire pour l'usage et l'usure de chaussures et de petit équipement personnels. 32,74€/an",
    "urlDoc": "https://www.emploi-collectivites.fr/icpe-prime-chaussures-blog-territorial",
    "ordre": 14,
    "eligibleEchelons": null,
    "primeType": "Conditions de travail",
    "eligibleStatuses": [
      "titulaire",
      "stagiaire",
      "contractuel"
    ],
    "aNegocier": false,
    "baseLegale": "Arrêté du 22/11/1951 modifié - Indemnité de chaussures et de petit équipement",
    "decretReference": "arr. 22/11/1951",
    "noteCalcul": "Montant annuel de 32,74€ soit 2,73€/mois. Compensation pour usure de l'équipement personnel."
  },
  {
    "id": "service",
    "nom": "Prime de service",
    "description": "Prime annuelle",
    "montantDefaut": 0,
    "montantUtilisateur": 0,
    "active": false,
    "type": "variable",
    "icon": Stethoscope,
    "color": "blue",
    "details": "Tient compte de l'assiduité, de l'évaluation professionnelle et du grade. 7,5% de la masse salariale.",
    "calculable": true,
    "availableForProfessions": [
      "infirmier",
      "infirmiere-anesthesiste-iade",
      "infirmiere-bloc-operatoire-ibode",
      "infirmiere-puericultrice-ipde",
      "infirmiere-pratique-avancee-ipa"
    ],
    "proratisee": false,
    "formuleCode": "service_formula",
    "calculDetails": "Tient compte de l'assiduité, de l'évaluation professionnelle et du grade. 7,5% de la masse salariale.",
    "urlDoc": "https://www.emploi-collectivites.fr/prime-service-fph-blog-territorial",
    "ordre": 15,
    "eligibleEchelons": null,
    "primeType": "Globale",
    "eligibleStatuses": [
      "titulaire",
      "stagiaire"
    ],
    "aNegocier": false,
    "baseLegale": "Décret n°68-929 du 24/10/1968 - Prime de service FPH",
    "decretReference": "68-929",
    "noteCalcul": "Montant annuel = 7,5% de la masse salariale, plafonné à 17% du traitement individuel.",
    "serviceTauxMax": 17,
    "isMaxCalculated": true
  },
  {
    "id": "insalubrite",
    "nom": "Prime d'insalubrité",
    "description": "Indemnité pour travaux dangereux, insalubres, incommodes ou salissants (ITDIIS)",
    "montantDefaut": 13.64,
    "montantUtilisateur": 13.64,
    "active": false,
    "type": "variable",
    "icon": Gift,
    "color": "gray",
    "details": "Compense les dangers et désagréments de missions exécutées dans un environnement insalubre.",
    "calculable": true,
    "availableForProfessions": [
      "infirmier",
      "infirmiere-anesthesiste-iade",
      "infirmiere-bloc-operatoire-ibode",
      "infirmiere-puericultrice-ipde",
      "infirmiere-pratique-avancee-ipa"
    ],
    "proratisee": true,
    "calculDetails": "Compense les dangers et désagréments de missions exécutées dans un environnement insalubre.",
    "urlDoc": "https://www.emploi-collectivites.fr/prime-travaux-salissants-blog-territorial",
    "ordre": 16,
    "eligibleEchelons": null,
    "primeType": "Conditions de travail",
    "eligibleStatuses": [
      "titulaire",
      "stagiaire",
      "contractuel"
    ],
    "aNegocier": false,
    "baseLegale": "Décret n°67-624 du 23/07/1967 - ITDIIS",
    "decretReference": "67-624",
    "noteCalcul": "Indemnité travaux dangereux, insalubres, incommodes ou salissants. 0,31€/demi-journée (catégorie 2).",
    "montantDemiJourneeInsalubrite": 0.31,
    "insalubriteCat2Config": {
      "joursTravaillesParMois": 22
    }
  },
  {
    "id": "autres",
    "nom": "Autres primes",
    "description": "Prime mensuelle variable selon l'établissement",
    "montantDefaut": 200,
    "montantUtilisateur": 200,
    "active": false,
    "type": "variable",
    "icon": Gift,
    "color": "gray",
    "details": "Varie selon la taille et le type d'établissement. Peut aller jusqu'à 200€ dans certains CHU.",
    "calculable": false,
    "availableForProfessions": [
      "infirmier",
      "infirmiere-anesthesiste-iade",
      "infirmiere-bloc-operatoire-ibode",
      "infirmiere-puericultrice-ipde",
      "infirmiere-pratique-avancee-ipa"
    ],
    "proratisee": true,
    "calculDetails": "Varie selon la taille et le type d'établissement. Peut aller jusqu'à 200€ dans certains CHU.",
    "ordre": 17,
    "eligibleEchelons": null,
    "primeType": "Globale",
    "eligibleStatuses": [
      "titulaire",
      "stagiaire",
      "contractuel"
    ],
    "aNegocier": true
  },
  {
    "id": "nbi",
    "nom": "Nouvelle Bonification Indiciaire (NBI)",
    "description": "Pour les emplois présentant une technicité, sujétions ou responsabilités particulières",
    "montantDefaut": 73.84,
    "montantUtilisateur": 73.84,
    "active": false,
    "type": "variable",
    "icon": Award,
    "color": "indigo",
    "details": "Versée aux fonctionnaires (stagiaires ou titulaires). Ne peut pas être versée à d'autres catégories (ex. contractuels).",
    "calculable": true,
    "availableForProfessions": [
      "infirmier",
      "infirmiere-anesthesiste-iade",
      "infirmiere-bloc-operatoire-ibode",
      "infirmiere-puericultrice-ipde",
      "infirmiere-pratique-avancee-ipa"
    ],
    "proratisee": true,
    "formuleCode": "nbi_formula",
    "calculDetails": "Versée aux fonctionnaires (stagiaires ou titulaires). Ne peut pas être versée à d'autres catégories (ex. contractuels).",
    "urlDoc": "https://www.fonction-publique.gouv.fr/etre-agent-public/ma-remuneration/les-elements-accessoires-de-remuneration/la-nouvelle-bonification-indiciaire-nbi",
    "ordre": 18,
    "eligibleEchelons": null,
    "primeType": "Globale",
    "eligibleStatuses": [
      "titulaire",
      "stagiaire"
    ],
    "aNegocier": false,
    "baseLegale": "Article 27 de la loi n°91-73 du 18/01/1991 - Décret n°94-139 du 14/02/1994",
    "decretReference": "94-139",
    "noteCalcul": "Réservée aux fonctionnaires (titulaires et stagiaires). Les contractuels en sont exclus.",
    "nbiConfig": {
      "points": 15
    }
  },
  {
    "id": "grand_age",
    "nom": "Prime Grand Âge",
    "description": "Prime versée aux personnels exerçant auprès de personnes âgées",
    "montantDefaut": 118,
    "montantUtilisateur": 118,
    "active": false,
    "type": "fixe",
    "icon": UserCheck,
    "color": "amber",
    "details": "Instituée par le décret n°2020-66 du 29/01/2020, attribuée aux agents exerçant dans les EHPAD et services gériatriques. Montant revalorisé à 118€ brut mensuel.",
    "calculable": false,
    "availableForProfessions": [
      "infirmier",
      "infirmiere-anesthesiste-iade",
      "infirmiere-bloc-operatoire-ibode",
      "infirmiere-puericultrice-ipde",
      "infirmiere-pratique-avancee-ipa"
    ],
    "proratisee": true,
    "calculDetails": "Instituée par le décret n°2020-66 du 29/01/2020, attribuée aux agents exerçant dans les EHPAD et services gériatriques. Montant revalorisé à 118€ brut mensuel.",
    "urlDoc": "https://www.legifrance.gouv.fr/jorf/id/JORFTEXT000041502545",
    "ordre": 19,
    "eligibleEchelons": null,
    "primeType": "Conditions de travail",
    "eligibleStatuses": [
      "titulaire",
      "stagiaire",
      "contractuel"
    ],
    "aNegocier": false,
    "baseLegale": "Décret n°2020-66 du 29/01/2020 - Prime grand âge FPH",
    "decretReference": "2020-66",
    "dateRevalorisation": "2020-05-01",
    "noteCalcul": "118€ brut mensuel pour exercice auprès de personnes âgées (EHPAD, USLD, gériatrie)."
  },
  {
    "id": "engagement_collectif",
    "nom": "Prime d'engagement collectif",
    "description": "Prime récompensant les équipes pour l'atteinte d'objectifs collectifs",
    "montantDefaut": 100,
    "montantUtilisateur": 100,
    "active": false,
    "type": "variable",
    "icon": HandHeart,
    "color": "emerald",
    "details": "Prime annuelle versée par l'établissement aux équipes ayant atteint des objectifs de qualité ou de productivité. Montant variable jusqu'à 1 200€ annuels par agent.",
    "calculable": false,
    "availableForProfessions": [
      "infirmier",
      "infirmiere-anesthesiste-iade",
      "infirmiere-bloc-operatoire-ibode",
      "infirmiere-puericultrice-ipde",
      "infirmiere-pratique-avancee-ipa"
    ],
    "proratisee": true,
    "calculDetails": "Prime annuelle versée par l'établissement aux équipes ayant atteint des objectifs de qualité ou de productivité. Montant variable jusqu'à 1 200€ annuels par agent.",
    "urlDoc": "https://www.legifrance.gouv.fr/loda/id/JORFTEXT000024505702",
    "ordre": 20,
    "eligibleEchelons": null,
    "primeType": "Globale",
    "eligibleStatuses": [
      "titulaire",
      "stagiaire",
      "contractuel"
    ],
    "aNegocier": false,
    "baseLegale": "Décret n°2011-1038 du 29/08/2011 - Prime d'intéressement collectif",
    "decretReference": "2011-1038",
    "dateRevalorisation": "2011-09-01",
    "noteCalcul": "Prime annuelle facultative, plafonnée à 1 200€/an par agent. Soumise à décision de l'établissement."
  },
  {
    "id": "tutorat",
    "nom": "Prime de tutorat et d'encadrement",
    "description": "Prime pour l'encadrement des étudiants stagiaires",
    "montantDefaut": 80,
    "montantUtilisateur": 80,
    "active": false,
    "type": "fixe",
    "icon": GraduationCap,
    "color": "blue",
    "details": "Versée aux infirmiers assurant le tutorat d'étudiants en soins infirmiers ou de stagiaires. Montant forfaitaire mensuel.",
    "calculable": false,
    "availableForProfessions": [
      "infirmier",
      "infirmiere-anesthesiste-iade",
      "infirmiere-bloc-operatoire-ibode",
      "infirmiere-puericultrice-ipde",
      "infirmiere-pratique-avancee-ipa"
    ],
    "proratisee": true,
    "calculDetails": "Versée aux infirmiers assurant le tutorat d'étudiants en soins infirmiers ou de stagiaires. Montant forfaitaire mensuel.",
    "urlDoc": "https://www.legifrance.gouv.fr/jorf/id/JORFTEXT000044636850",
    "ordre": 21,
    "eligibleEchelons": null,
    "primeType": "Conditions de travail",
    "eligibleStatuses": [
      "titulaire",
      "stagiaire",
      "contractuel"
    ],
    "aNegocier": false,
    "baseLegale": "Décret n°2021-1905 du 30/12/2021 - Indemnité pour les tuteurs de stagiaires FPH",
    "decretReference": "2021-1905",
    "dateRevalorisation": "2022-01-01",
    "noteCalcul": "Forfait mensuel versé pour le tutorat effectif d'un étudiant en soins infirmiers."
  }
];
